module.exports = __webpack_public_path__ + "static/media/mlHorizontalHAV.117a2ea3.png";